<template>
  <div id="input">
    <v-container fluid tag="section" class="tabs py-0 pt-1">
      <v-tabs v-model="tab" background-color="transparent" show-arrows height="40">
        <v-tab
          v-for="tab in inputTabs"
          :key="tab"
          :href="`#${tab}`"
          active-class="v-tab-active-class"
        >
          {{ $t(`views.input.tabs.${tab}`) }}
        </v-tab>
      </v-tabs>
    </v-container>

    <v-container class="tabs-items" fluid tag="section">
      <v-tabs-items v-model="tab" class="transparent-background" touchless>
        <v-tab-item value="orders" :transition="false" :reverse-transition="false">
          <InputOrders />
        </v-tab-item>
        <v-tab-item value="dividends" :transition="false" :reverse-transition="false">
          <InputDividends />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </div>
</template>

<script>
import InputOrders from './InputOrders'
import InputDividends from './InputDividends.vue'
import gtag from '@/lib/gtag'

export default {
  components: {
    InputOrders,
    InputDividends,
  },
  data: () => ({
    tab: null,
    inputTabs: ['orders', 'dividends'],
  }),
  watch: {
    tab() {
      gtag.pageview({
        pagePath: `/input/${this.tab}`,
        pageTitle: `input|${this.tab}`,
        pageContentGroup: 'page',
      })
    },
  },
}
</script>
